export enum SituacaoNotificacaoEnum {
  criada = 1,
  enviada = 2,
  recebida = 3,
  visualizada = 4,
}
